import React from 'react';
import PropTypes from 'prop-types';

// components
import { viewMore } from '../../pdpMessages';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
// styles
import styles from './PdpRespSimilarItemsContainer.scss';

// helpers
import classnames from 'classnames';

function PdpRespSimilarItemsContainer(props) {
    const { header, subtitle, children, dataTn, ...options } = props;
    const outerClass = classnames(styles.outer, {
        [styles.isDark]: options.isDark,
        [styles.hideBar]: options.hideBar,
    });
    const innerClass = classnames(styles.inner, 'primary-viewport-width', {
        [styles.hasSubtitle]: !!subtitle,
    });
    const contentClass = classnames(styles.content, 'primary-page-width');
    const subtitleClass = classnames(styles.subtitle, { [styles.hasHeader]: !!header });

    return (
        <div className={outerClass} data-tn={dataTn}>
            {/* FULL WIDTH OF WINDOW */}
            <div className={innerClass}>
                {/* Header */}
                {!!header && <BarHeader title={header} />}

                {/* FULL WIDTH OF PAGE */}
                <div className={contentClass}>
                    {!!subtitle && (
                        <div className={subtitleClass}>
                            {subtitle}{' '}
                            {
                                <span className={styles.viewMore} onClick={options.onClickViewMore}>
                                    {viewMore}
                                </span>
                            }
                        </div>
                    )}
                    {/* Grid of Items */}
                    {children}
                </div>
            </div>
        </div>
    );
}

PdpRespSimilarItemsContainer.propTypes = {
    header: PropTypes.node,
    subtitle: PropTypes.node,
    children: PropTypes.node,
    dataTn: PropTypes.string.isRequired,

    // options
    isDark: PropTypes.bool,
    hideBar: PropTypes.bool,
    onClickViewMore: PropTypes.func,
};

export default PdpRespSimilarItemsContainer;
